"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isShorterThan_1 = require("./isShorterThan");
// returns true if input array's length is less than 1
const isShort = isShorterThan_1.default(1);
exports.default = isShort;
